import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Services } from "appworks/services/services";
import { slotModel } from "slotworks/model/slot-model";
import { RadioControl } from "./radio-control";

export class AutoSingleWinRadioControl extends RadioControl {

    constructor(protected buttons: FlexiButton[], protected labels: FlexiText[], protected leftArrow?: FlexiButton, protected rightArrow?: FlexiButton, decimals: boolean = true) {
        super(buttons, labels, leftArrow, rightArrow);

        this.setFormatMethod((value: number) => {
            if (value === Number.MAX_VALUE) {
                return Services.translations.getFirstValid(["infinity", "curr.inf"]);
            } else {
                return Services.currency.format(value, decimals);
            }
        });
        const singleWinLimit = slotModel.read().autoplay.singleWinLimit;
        singleWinLimit.currentValue = undefined;
        this.setValues(singleWinLimit.values, singleWinLimit.currentValue);
        this.onChange(singleWinLimit.values.indexOf(singleWinLimit.currentValue), singleWinLimit.currentValue);

        slotModel.onUpdate.add(() => {
            const newSingleWinLimit = slotModel.read().autoplay.singleWinLimit;
            this.setValues(newSingleWinLimit.values, newSingleWinLimit.currentValue);
            this.onChange(newSingleWinLimit.values.indexOf(newSingleWinLimit.currentValue), newSingleWinLimit.currentValue);
        });
    }

    protected onChange(index: number, value: number): void {
        super.onChange(index, value);

        const autoplay = slotModel.read().autoplay;

        if (value !== autoplay.singleWinLimit.currentValue) {
            autoplay.singleWinLimit.currentValue = value;
            slotModel.write({ autoplay });
        }
    }
}
